import { useAccountStore } from '@/stores/accountStore';

const LEGACY_LAST_STAKE_KEY = 'ds';

function resolveLastStakeKey(): string | null {
    const { customerInfo, hashedAccountId } = useAccountStore();
    return customerInfo.accountId
        ? `${LEGACY_LAST_STAKE_KEY}:${hashedAccountId}`
        : null;
}

function adoptLegacyLastStake(key: string) {
    const legacyStake = window.localStorage.getItem(LEGACY_LAST_STAKE_KEY);
    if (legacyStake === null) {
        return;
    }
    if (window.localStorage.getItem(key) === null) {
        window.localStorage.setItem(key, legacyStake);
    }
    window.localStorage.removeItem(LEGACY_LAST_STAKE_KEY);
}

function readLastStakeRecord(): string | null {
    const key = resolveLastStakeKey();
    if (key === null) {
        return null;
    }
    adoptLegacyLastStake(key);
    return window.localStorage.getItem(key);
}

export function hasLastStake(): boolean {
    return readLastStakeRecord() !== null;
}

export function getLastStake(): number {
    const record = readLastStakeRecord();
    if (record === null) {
        return 0;
    }
    const stake = Number.parseInt(record);
    return Number.isNaN(stake) || stake < 0 ? 0 : stake;
}

export function saveLastStake(stake: number): void {
    const key = resolveLastStakeKey();
    if (key === null) {
        return;
    }
    adoptLegacyLastStake(key);
    window.localStorage.setItem(key, stake.toString());
}
